import { Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { PATHS } from 'commons/paths';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'hooks/useAuth';
import { Button } from 'atoms/Button';
import { TransitionButton } from 'atoms/TransitionButton';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';

type LogoutModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const LogoutDialog = ({ open, setOpen }: LogoutModalProps) => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const { t: tCommons } = useTranslationWithLang('commons');

  const handleLogout = async () => {
    try {
      await signOut();
      await navigate(PATHS.LOGIN);
    } catch (error) {
      console.error('ログアウトエラー', error);
      alert(tCommons('TU000_053'));
    }
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: {
            color: 'var(--c-text)',
            padding: '20px',
            borderRadius: '10px',
            backgroundColor: 'var(--c-background2)',
            boxShadow: '0 3px 10px rgba(0, 0, 0, 0.2)',
          },
        }}
      >
        <DialogTitle style={{ fontWeight: 'bold', textAlign: 'center' }}>
          {tCommons('TU000_049')}
        </DialogTitle>
        <DialogContent className="text-center">{tCommons('TU000_050')}</DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <TransitionButton
            label={tCommons('TU000_051')}
            onClick={() => setOpen(false)}
            className="mr-2"
          />
          <Button label={tCommons('TU000_052')} onClick={handleLogout} />
        </DialogActions>
      </Dialog>
    </>
  );
};
